export enum DataHubPath {
  EXPORT_SELECTION = 'export-selection',
  PAST_EXPORTS = 'past-exports'
}

export const DATAHUB_DEFAULT_GROUP = 'Prod_Indexes';
